import { AnchorHTMLAttributes } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { DataTrackingTypeHTMLElement } from '@hhgtech/hhg-components/types'
import { Stethoscope, Hospital } from '@hhgtech/icons/other'
import { Box, Flex, Rating, Stack, StackProps, rem } from '@mantine/core'

import { useRouterExtend } from 'hooks/useRouterExtend'

import { CardItem } from '.'

type Props = {
  item: CardItem
  hidePrice?: boolean
  rating?: string
  hideRating?: boolean
  hrefProps?: AnchorHTMLAttributes<HTMLAnchorElement> &
    DataTrackingTypeHTMLElement
} & StackProps

const Info = ({ item, hidePrice, hideRating, hrefProps, ...rest }: Props) => {
  const { locale } = useRouterExtend()
  const {
    name,
    rating,
    doctorSpecialties = [],
    hospital,
    price,
    priceUnit,
    originalPrice,
    cityName,
  } = item
  const formatedRating = Math.floor(Number(rating))
  const ratingEle =
    formatedRating > 0 ? (
      <Flex gap={rem(8)} align={'center'}>
        <Rating defaultValue={formatedRating} readOnly />
        <Text size="s4" weight="semiBold">
          {parseFloat(rating)}/5
        </Text>
      </Flex>
    ) : null
  return (
    <Stack spacing={rem(8)} justify="space-between" {...rest}>
      <Stack spacing={rem(8)}>
        <a {...hrefProps}>
          <Text size="s3" weight="semiBold">
            {name}
          </Text>
        </a>
        {!hideRating && ratingEle}
        <Stack spacing={rem(4)}>
          {!hidePrice && price && (
            <Flex align={'center'} gap={rem(8)}>
              <Box>
                <img
                  loading="lazy"
                  src="/svg/price-outline.svg"
                  style={{ width: rem(20), display: 'block' }}
                  alt="Price"
                />
              </Box>
              <Text size="p4" color="green.6" weight="semiBold">
                {Intl.NumberFormat(locale).format(parseInt(price))} {priceUnit}
              </Text>
              {originalPrice && (
                <Text
                  size="p4"
                  color="gray.4"
                  weight="semiBold"
                  sx={{
                    textDecoration: 'line-through',
                  }}
                >
                  {Intl.NumberFormat(locale).format(parseInt(originalPrice))}{' '}
                  {priceUnit}
                </Text>
              )}
            </Flex>
          )}
          {doctorSpecialties.length > 0 && (
            <Flex align={'flex-start'} gap={rem(8)}>
              <Box>
                <Stethoscope size={20} />
              </Box>
              <Text size="p4">{doctorSpecialties.join(', ')}</Text>
            </Flex>
          )}
          {hospital && (
            <Flex align={'flex-start'} gap={rem(8)}>
              <Box>
                <Hospital size={20} />
              </Box>
              <Text size="p4">{hospital}</Text>
            </Flex>
          )}
          {cityName && (
            <Flex align={'flex-start'} gap={rem(8)}>
              <Box>
                <img
                  loading="lazy"
                  src="/svg/location-outline.svg"
                  style={{ width: rem(20), display: 'block' }}
                  alt="Price"
                />
              </Box>
              <Text size="p4">{cityName}</Text>
            </Flex>
          )}
        </Stack>
      </Stack>
    </Stack>
  )
}

export { Info }
